import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=afc034a8&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=js&"
export * from "./ColumnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc034a8",
  null
  
)

export default component.exports